import { modifier } from 'ember-modifier';

const htmlToElement = function (html) {
  let template = document.createElement('div');
  html = html.trim();
  template.innerHTML = html;

  return template.firstChild;
};

export default modifier((element, [numOfRecommendedParts]) => {
  let partCountCircle = element.querySelector('.part-count-circle');
  if (partCountCircle) {
    if (partCountCircle.remove) {
      partCountCircle.remove();
    } else {
      partCountCircle.parentNode.removeChild(partCountCircle); // IE11 Compatibility
    }
  }

  if (numOfRecommendedParts > 0) {
    let recommendedIcon = element.children[1];
    let htmlCircle = htmlToElement(
      '<div class="part-count-circle" data-qa-element="dt_recommended_tab_item_count">' +
        numOfRecommendedParts +
        '</div>',
    );
    recommendedIcon.parentNode.insertBefore(htmlCircle, recommendedIcon.nextSibling);
  }
});
